import { AttackFramework, withStyling } from "@ticore/metadata";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { route } from "../../../../shim/jsbridge";
import { useCloudData } from "../../hooks";

const CloudMitreAttack: React.FC = () => {
  const { hash: sha1 = "" } = useParams();
  const {
    sampleData: { mitre }
  } = useCloudData(sha1);
  const navigate = useNavigate();

  const onTechniqueIdClick = (technique: string) => {
    navigate(
      route("search", [], {
        location: "cloud",
        q: `attack-technique: "${technique}"`
      })
    );
  };

  return (
    <div className="ticore-metadata">
      <AttackFramework
        attack={{ [mitre?.name]: mitre?.tactics }}
        iconTooltipText="Look Up on Search"
        onTechniqueIdClick={onTechniqueIdClick}
      />
    </div>
  );
};

export default withStyling(CloudMitreAttack);
